export const videoBadgeColourMapping = {
  Kindness: "#FF02B4",
  Helpfulness: "#34a853",
  Honesty: "#ff0000",
  Respectfulness: "#ff8102",
  Politeness: "#cc0e2e",
  Patience: "#ff00ff",
  Righteousness: "#0058ff",
};

export const characterAltMapping = {
  muskan:
    "Muskaan, an angel of values wearing a white, pink and blue robe. She has yellow wings and also a halo over her head",
  meendu:
    "The main character named Meendu who has a waffle body and a blue ice cream scoop as hair.",
  meendu_mom:
    "Meendu’s elegant mom. She is a light-coloured waffle ice cream with red hair and two wafers sit in her hair as clips.",
  meendu_dad:
    "Meendu’s smart dad. He is light coloured ice cream waffle with brown hair. He wears spectacles and a red tie.",
  meendu_grandma:
    "Meendu’s wise grandmother. She is an ice cream waffle with grey-white hair as scoop, decorated with colourful sprinkles. She has pink lips and wears spectacles.",
  meendu_grandpa:
    "He is Meendu’s grandfather. He is a dark brown ice cream waffle with light coloured face as scoop. He is bald with traces of white-grey hair. He also wears spectacles and a red scarf around his neck.",
  icy: "An ice cream cartoon character with waffle body and white ice cream scoop as face. Icy also has a few chocolate drops dripping from his head. He has big eyes, smiling lips and waving hands.",
  cookie:
    "Cookie is Icy’s little sister and Meendu’s friend. She is a pink coloured cup ice cream with white and yellow coloured ice cream scoop as her head. She also has small oval shaped eyes, little hands and a pink cherry over her head",
  mellow:
    "Purple colour marsh mellow with big round eyes and pink blush cheeks. Mellow is a small kid who talks in jumbled words.",
  daisy:
    "Meendu’s friend. She is a tricolored popsicle with yellow, orange, and pink stripes.",
  teacher:
    "Meendu’s teacher. She is a pink coloured popsicle with beautiful dark pink hair.",
  mr_john: "He is a white coloured vanilla popsicle with shaded blue hair.",
  granny:
    "Grandma’s best friend. She is light coloured ice cream waffle with shaded purple hair as scoop. She wears spectacles and holds a walking stick in her hand.",
};

export const getCategoryColour = (category) => {
  return videoBadgeColourMapping[category] ?? "#EF4444"; // default red
};

export const getAltForCharacter = (character) => {
  return characterAltMapping[character] ?? "MeenduToons Character Image"; //default Alt
};

export const convertVimeoUrl = (url) => {
  const regex = /vimeo\.com\/(\d+)/;
  const match = url.match(regex);
  if (match && match[1]) {
    return `https://player.vimeo.com/video/${match[1]}`;
  }
  return null;  // or handle the case where the URL format is incorrect
}

export const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

export const testimonialsData = [
  {
    img: "Ameya_Choudhari",
    name: "Ameya Choudhari",
    subtext: "(Parent of a 5 year old)",
    text: "My 5 year old son finds the videos very engaging. He asked a ton of questions after watching the videos which points to the fact that they are thought-provoking as well"
  },
  {
    img: "Shreen",
    name: "Miss Shreen",
    text: "I like MeenduToons because it is funny and the ice cream characters are cute. MeenduToons teaches little kids good manners in funny videos. I like the angel of values and when the kids say “I spy kindness!”. I also think that MeenduToons is funny, nice and good for little kids education"
  },
  {
    img: "Pareena_Rai",
    name: "Pareena Rai",
    subtext: "(Parent of a 6 year old)",
    text: "MeenduToons is a very interesting and fresh concept. My daughter Meera is intrigued to watch all the videos. She has learnt a lot of new values. I can see the change in her"
  },
  {
    img: "Saanvi",
    name: "Miss Saanvi",
    text: "I think MeenduToons is a very good channel for little kids because they can learn good manners and it has cute characters. I like the stories they tell, and how they teach just by telling a story. I also like the angel of values, she’s nice and pretty"
  },
  {
    img: "Kritika_Mathur",
    name: "Kritika Mathur",
    subtext: "(Parent of a 4 year old)",
    text: "As a mother to a 4 year old son, I highly recommend MeenduToons to parents who wish to raise their children to be individuals with strong values"
  },
  {
    img: "Avyaan",
    name: "Master Avyaan",
    text: "Really love watching MeenduToons. My favorite character is Meendu. He always teaches me good things"
  },
  {
    img: "Shilpi_Mathur",
    name: "Shilpi Mathur",
    subtext: "(Parent of twins)",
    text: "MeenduToons is a great resource for teaching kindness to my twin boys. With MeenduToons’ beautiful stories, it is easier to teach kids that kindness is all inclusive. Thank you Meendutoons for spreading kindness & positivity"
  }
]

export const getOrderAmount = (plan) => {
  switch(plan) {
      case "MONTHLY":
          return 114;
      case "QUARTERLY":
          return 287;
      case "ANNUALLY":
          return 1092;
      default:
          return 114;
  }
}
